const fromTo = (result, page, hitsPerPage) => {
  const {length} = result.hits;
  const from = !length ? 0 : !page ? 1 : (page * hitsPerPage) + 1;
  const to = !from ? 0 : from + length - 1;

  return `${from}-${to}`;
};

export default fromTo;
